/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_012: Question = {
  id: 'multi-012-programmes-sensibilisation-reconnaissance',
  oldId: '73',
  title: 'Participation à des programmes de sensibilisation ou de reconnaissance',
  number: '7.4',
  description: ['L\'organisation participe à des programmes nationaux ou internationaux de sensibilisation à la biodiversité ou de reconnaissance des actions posées'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 14,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_multi_012_v2: Question = question_multi_012;
export const question_multi_012_v3: Question = question_multi_012;
